/**
 * Validates that input does not contain special characters.
 * Blocked characters: ` ! @ # $ % ^ & * ( ) _ + - = { } ; ' : " \ | . < > / ? ~
 * @param {string} inputValue - The string to validate
 * @returns {string|undefined} Error message if invalid, undefined if valid
 */
export const validateSpecialCharacters = (inputValue) => {
  const specialChars = /[`!@#$%^&*()_+\-={};':"\\|.<>/?~]/;
  if (specialChars.test(inputValue)) {
    return "Input may not contain [`!@#$%^&*()_+-={};':\"\\|,.<>/?~]";
  }
  return undefined;
};

/**
 * Validates that input is a valid email address format.
 * @param {string} inputValue - The string to validate
 * @returns {string|undefined} Error message if invalid, undefined if valid
 */
export const validateEmail = (inputValue) => {
  if (!inputValue) {
    return undefined;
  }
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!emailRegex.test(inputValue)) {
    return "Please enter a valid email address";
  }
  return undefined;
};
